export default __webpack_public_path__ + "static/media/zoom_in.9cbdcce4.svg";